import { routePaths } from "src/admin/modules/order/constants.ts";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import { AppVariation } from "src/client-config/getClientConfig.ts";
import type { Module } from "src/system/module.types.ts";
import type { OrderResource } from "@exonn/js-sdk";

const createRouteObject = {
  path: routePaths.create.root,
  lazy: () =>
    import(
      "src/admin/modules/order/routes/create/create-order/create.general.tsx"
    ),
};

export const module: Module<OrderResource> = {
  id: ResourceEnum.Order,
  smallIcon: <i className={"icon-15-custm_ord"} />,
  bigIcon: <i className={"icon-20-custm_ord"} />,
  name: (t: TFunction) => t("moduleName.orders"),

  disableCreate: ({ clientConfig }) => {
    return clientConfig.appVariation === AppVariation.B2bGateSupplier;
  },
  disableDelete: true,
  create: {
    routeObject: createRouteObject,
  },
  tabs: {
    edit: {
      getTitle: (resource) => resource.number,
    },
  },

  formTabs: {
    general: {
      title: (t) => t("tabs.general"),
    },
    address: {
      title: (t) => t("tabs.address"),
    },
    shipping: {
      title: (t) => t("tabs.shipping"),
    },
  },
};
